/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./feature-tag-config.vue?vue&type=template&id=a9339586&"
import script from "./feature-tag-config.vue?vue&type=script&lang=js&"
export * from "./feature-tag-config.vue?vue&type=script&lang=js&"
import style0 from "./feature-tag-config.vue?vue&type=style&index=0&id=a9339586&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports